import { getGeneralInfo, getImagesHandler } from "./setSellMyCarForms"

const parsedVehicle = (selectedCar) => {
  const images = [];
  const carImages = getImagesHandler({
    data: {
      vehicle: selectedCar
    }
  });

  for (let i = 0; i < Object.entries(carImages?.images)?.length; i++) {
    for (let j = 0; j < Object.entries(carImages?.images)?.[i]?.[1]?.length; j++) {
      if (Object.entries(carImages?.images)?.[i]?.[1]?.[j]) {
        images.push(Object.entries(carImages?.images)?.[i]?.[1]?.[j])
      }
    }
  }

  return {
    ...selectedCar,
    images
  };
}

const getVehicleInfoHandler = (car) => {
  const { accessories, ...rest } = getGeneralInfo({
    data: {
      vehicle: car,
    },
  });
  return rest;
};

export {
  parsedVehicle,
  getVehicleInfoHandler
};